import Toaster, { ToasterContext } from './Toaster';

export { ToasterContext };
export default Toaster;
